<script>
import lottie from 'lottie-web'

export default {
    name: "LottieAnimationElement",
    mixins: [],
    data () {
        return {
            elementType: 'lottie-animation',
            lottieInstance: null, // The lottie animation instance
            io: null, // The intersection observer to check if lootie is in viewport
            animationContainer: null,
            isHovered: false, // Whether the animation is currently being hovered or not
            isInView: false // Whether the animation is inside the viewport
        }
    },
    computed: {
        getDefaultDataStructure () {
            return {
                elementType: this.elementType,
                elementId: this.elementId,
                styles: null,
                linkData: {},
                responsiveAlignmentClass: {
                    'desktop': '',
                    'tablet-portrait': '',
                    'tablet-landscape': '',
                    'smartphone-portrait': '',
                    'smartphone-landscape': ''
                },
                uploadedJsons: [], // This is kind of a workaround to not involve creating a new db repo, uploaded jsons are kept per component
                playOn: "pageLoad", // "pageLoad", "viewport", "hover", "never"
                animationPath: "",
                animationLoop: true,
                animationSpeed: 1,
                animationDirection: 1, // 1 -> forward, -1 -> backward
            }
        },
        uploadedJsons(){return this.myData.uploadedJsons},
        playOn(){return this.myData.playOn},
        shouldPlay() {
            const playCondition = this.playOn === "pageLoad" || (this.playOn === "hover" && this.isHovered)  || (this.playOn === "viewport" && this.isInView);
            return this.playOn !== "never" && playCondition;
        },
        animationPath(){ return this.myData.animationPath },
        animationLoop(){ return this.myData.animationLoop },
        animationSpeed(){ return this.myData.animationSpeed },
        animationDirection(){ return this.myData.animationDirection },
    },
    methods: {
        mountAnimation() {
            if (!this.animationPath) return;

            // Destroy exiting lottie instance if exists
            this.lottieInstance?.destroy();

            // In case the url is relative, make it absolute (Might not be needed)
            const animationUrl = (new URL(this.myData.animationPath, window.location.href)).toString();

            // Clear the container of any leftover content left when page got saved (workaround, another solution should be explored)
            this.animationContainer.innerHTML = "";

            this.lottieInstance = lottie.loadAnimation({
                container: this.animationContainer,
                renderer: 'svg',
                loop: this.animationLoop,
                autoplay: this.shouldPlay,
                path: animationUrl,
                rendererSettings: {
                    progressiveLoad: true,
                },
            });

            this.lottieInstance.setSpeed(this.animationSpeed);
            this.lottieInstance.setDirection(this.animationDirection);
        },
        addUploadedJson(jsonUrl) {
            if (this.myData.uploadedJsons.includes(jsonUrl)) {
                return
            }
            const jsons = [...this.myData.uploadedJsons, jsonUrl];
            this.changeMyData({"uploadedJsons": jsons});
        },
        playAnimation() {
            if(this.animationDirection === 1) {
                this.lottieInstance.play();
            } else {
                this.lottieInstance.goToAndPlay(this.lottieInstance.firstFrame + this.lottieInstance.totalFrames - 1, true);
            }
        },

        // Getters and Setters
        getAnimationPath(){
            return this.myData.animationPath;
        },
        setAnimationPath(v) {
            this.changeMyData({animationPath: v});
        },
        getAnimationLoop(){
            return this.myData.animationLoop;
        },
        setAnimationLoop(v) {
            this.lottieInstance.loop = v;
            if(v && this.shouldPlay) {
                this.playAnimation();
            }
            this.changeMyData({animationLoop: v});
        },
        getPlayOn(){
            return this.myData.playOn;
        },
        setPlayOn(v) {
            this.changeMyData({playOn: v});
        },
        getAnimationSpeed(){
            return this.myData.animationSpeed;
        },
        setAnimationSpeed(v) {
            this.lottieInstance.setSpeed(v);
            this.changeMyData({animationSpeed: v});
        },
        getAnimationDirection(){
            return this.myData.animationDirection;
        },
        setAnimationDirection(v) {
            this.lottieInstance.setDirection(v);
            this.changeMyData({animationDirection: v});
        },
    },
    created() {
        this.animationContainer = this.myNode.querySelector(".js-lottie-container");

        // Cannot create animation here because myData isn't populated yet.
        // Created though the animationPath watcher.

        // Hover watchers
        this.animationContainer.addEventListener('mouseenter', e => this.isHovered = true);
        this.animationContainer.addEventListener('mouseleave', e => this.isHovered = false);

        // Viewport watcher
        if ("IntersectionObserver" in window) {
            this.io = new IntersectionObserver(entries => this.isInView = entries[0].isIntersecting);
            this.io.observe(this.animationContainer);
        }
    },
    beforeDestroy() {
        this.lottieInstance?.destroy();
        this.io?.disconnect();
    },
    watch: {
        animationPath() {
            // Take the default template animation if none configured
            this.setAnimationPath(this.animationPath || this.myNode.dataset.lottieAnimationPath);
            this.mountAnimation();
        },
        shouldPlay(newVal) {
            if(!this.lottieInstance) return;
            newVal ? this.playAnimation() : this.lottieInstance.stop();
        }
    }
}
</script>